
import { defineComponent } from 'vue'
import { PostContentConstraints } from '@/validation/postValidator'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'PostTextCounter',
  components: { AIcon },
  props: {
    input: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      CONTENT_MAX_LENGTH: PostContentConstraints.MAX_LENGTH,
    }
  },
  computed: {
    currentContentLength(): number {
      let currentLength = 0

      if (typeof this.input !== 'undefined') {
        currentLength = this.CONTENT_MAX_LENGTH - this.input.length
      }

      return currentLength
    },
  },
})
